import React from 'react';
import { useStyles } from './styles';
import { ModalActionButton, ModalActions } from '@topconagriculture/modal';
import { useTranslation } from 'react-i18next';
import { ViewMore } from '../../../ViewMore/ViewMore';
export const ModalFooter = ({ closeModal, viewMore, disabled }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    return (React.createElement(ModalActions, null,
        React.createElement("div", { className: classes.cancel },
            React.createElement(ModalActionButton, { action: closeModal, btnLabel: t('common:close') })),
        React.createElement("div", { className: classes.viewMore },
            React.createElement(ViewMore, { disabled: disabled, viewMore: viewMore }))));
};
//# sourceMappingURL=ModalFooter.js.map